
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useFetch } from '../../../services/transports';
import { searchGenericName } from '../../../api/drug';
import { LabeledSelect } from '..';

export const DrugGenericNameDropdown = ({
  label,
  id,
  onChange,
  withAsterisks,
  disabled,
  value }) => {

  const [ t ] = useTranslation();

  const [ options, setOptions ] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [ { data }, fetchSearchGenericName ] = useFetch(searchGenericName,
    useCallback(response => {
      const container = response?.data?.container;
      if (container) {
        setOptions(container.map(i => ({ value: `${i.Id}`, text: `${i.GenericName}`, item: i })));
      }
    }));

  const onSearch = useCallback(query => {
    !!query && fetchSearchGenericName({ q: query.trim() });
  }, [ fetchSearchGenericName ]);

  return (
    <LabeledSelect
      label={ label }
      setValueAsObject
      onSearch={ onSearch }
      id={ id }
      onChange={ onChange }
      showSearch={ true }
      searchDelay={ 250 }
      options={ options }
      filterOption={ false }
      withDebounceSearch={ true }
      withAsterisks={ withAsterisks }
      disabled={ disabled }
      EmptyComponent={ t('ERR.noMatchedGenericName') }
      allowClear
      value={ value?.value }
    />
  );
};
